import { lazy } from 'react';
import { createBrowserRouter } from 'react-router';
import * as routePath from '../common/utils/routePath';
import MaintenancePage from '../pages/MaintenancePage';
import registerRoutes from '../pages/register/RegisterRoute';
import serviceAreasRoutes from '../pages/service-areas/ServiceAreasRoute';
import workOrdersRoutes from '../pages/work-orders/WorkOrdersRoute';
import Layout from './views/Layout';

const LandingPage = lazy(() => import('../pages/landing/LandingPage'));
const CalendarPage = lazy(() => import('../pages/calendar/CalendarPage'));
const CompanySettingsPage = lazy(
  () => import('../pages/company-settings/CompanySettingsPage'),
);
const WorkOrderReportsPage = lazy(
  () => import('../pages/reports/WorkOrderReportsPage'),
);
const AppliancesPage = lazy(() => import('../pages/appliances/AppliancesPage'));
const NoAccessPage = lazy(() => import('../pages/NoAccessPage'));
const NotFound = lazy(() => import('./views/NotFound'));
const NotAllowed = lazy(() => import('./views/NotAllowed'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: routePath.maintenanceRoute, element: <MaintenancePage /> },
      { path: routePath.homeRoute, element: <LandingPage /> },
      ...registerRoutes,
      ...workOrdersRoutes,
      ...serviceAreasRoutes,
      { path: routePath.applianceRoute, element: <AppliancesPage /> },
      { path: routePath.calendarRoute, element: <CalendarPage /> },
      {
        path: routePath.companySettingsRoute,
        element: <CompanySettingsPage />,
      },
      {
        path: routePath.workOrderReportsRoute,
        element: <WorkOrderReportsPage />,
      },
      { path: routePath.noAccessRoute, element: <NoAccessPage /> },
      { path: routePath.notAllowedRoute, element: <NotAllowed /> },
      { path: routePath.notFoundRoute, element: <NotFound /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
